import styled from "styled-components";
import { FilterBox } from "../styles.po";

export const DDPoDesktopPage = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DDPoDesktopTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #293142;
  margin: 0;
`;

export const DDPoTab = styled(FilterBox)``;

export const CellText = styled.span`
  font-size: 14px;
`;

export const DeliveryAtCell = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  svg {
    flex-shrink: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PoIdCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
`;

export const PoIdLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #293142;
  text-decoration: ${({ $clickable }) => ($clickable ? "underline" : "none")};
  text-decoration-style: ${({ $clickable }) => ($clickable ? "dotted" : "unset")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: ${(props) => (props.$hasDoc ? "pointer" : "not-allowed")};

  svg,
  img {
    width: 16px;
    height: 16px;
  }
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ViewDetailsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #ef4f5f;
  white-space: nowrap;
`;
